module.exports = __webpack_public_path__ + "static/media/curly-left.4f5a8ad4.svg";